import { useState } from "react";
import { Tab, Tabs } from "@mui/material";

import { useTranslation } from "react-i18next";

import { SectionCard } from "components/SectionCard/SectionCard";
import { IZone } from "interfaces/zone.interface";

import { NotificationLogsScreen } from "../zoneSettings/modules/notificationLogs/NotificationLogsScreen";
import { RulesScreen } from "../zoneSettings/modules/rules/RulesScreen";

type NotificationRulesAndLogsProps = {
  type: "zone" | "subject";
  entityId: string;
  zone: IZone;
  zones: IZone[];
};

function NotificationRulesAndLogs({
  type,
  entityId,
  zone,
  zones,
}: NotificationRulesAndLogsProps) {
  const { t } = useTranslation();

  const [tabIndex, setTabIndex] = useState(0);

  const tabs = [
    <RulesScreen
      key={"rules"}
      entityId={entityId}
      ruleEntityType={type}
      zone={zone}
      zones={zones}
    />,
    <NotificationLogsScreen key={"logs"} entityId={entityId} zones={zones} />,
  ];

  return (
    <SectionCard title={t("notification_rules_and_logs")}>
      <Tabs value={tabIndex} onChange={(_, val) => setTabIndex(val)}>
        <Tab label={t("zone_rules")} />
        <Tab label={t("log")} />
      </Tabs>
      {tabs[tabIndex]}
    </SectionCard>
  );
}

export default NotificationRulesAndLogs;
